// Absolute base for step navigation. IntegrationWizardPage is the element of the
// `/integration-wizard/*` splat route, and react-router v7 resolves a *relative*
// path from within a splat against the full matched pathname — so a relative
// `navigate('steps/x')` appends instead of replacing, nesting
// `steps/invite-team/steps/invite-team/...` until the route no longer matches
// (blank page). Navigating to an absolute path avoids that entirely (PRE-3299).
export const WIZARD_STEPS_PATH = '/integration-wizard/steps';

export const StepCodes = {
  Personalisation: 'personalisation',
  InviteTeamMember: 'invite-team',
  Integrate: 'suggested-integration',
  VerifyIntegration: 'domain',
  StartRendering: 'verification',
} as const;

export type StepCode = typeof StepCodes[keyof typeof StepCodes];

export type WizardStep = {
  code: StepCode;
  path: string;
  title: string;
};

export const FULL_WIZARD_STEPS: WizardStep[] = [
  { code: StepCodes.Personalisation, title: 'Personalisation', path: 'onboarding-survey' },
  { code: StepCodes.InviteTeamMember, title: 'Invite Team', path: 'invite-team' },
  { code: StepCodes.Integrate, title: 'Integrate', path: 'integration' },
  { code: StepCodes.VerifyIntegration, title: 'Verify Integration', path: 'verify-integration' },
  { code: StepCodes.StartRendering, title: 'Start Rendering', path: 'verification' },
];

export const CodeToPath: Record<StepCode, string> = FULL_WIZARD_STEPS.reduce((acc, step) => {
  acc[step.code] = step.path;
  return acc;
}, {} as Record<StepCode, string>);
